import { Component, OnDestroy, OnInit } from "@angular/core";
import { RequestsSelectionService } from "./requests-selection-service";
import { RequestsService } from "../../services/requests.service";
import { Subscription } from "rxjs";
import { RequestSearchedDto } from "../../models/request/request-searched.dto";

@Component({
    selector: 'search-requests-autocomplete',
    templateUrl: './search-requests-autocomplete.component.html',
    styleUrls: ['./search-requests-autocomplete.component.scss']
})
export class SearchRequestsAutoCompleteComponent implements OnInit, OnDestroy {

    minCharactesCount: number = 2;

    requests: RequestSearchedDto[] = [];

    requestsSelectionSubscription: any;

    searchPauseTime = 500;
    searchDelay: NodeJS.Timer;
    searchSubsription: Subscription;
    searching: boolean = false;

    constructor(
        public requestsService: RequestsService,
        public requestsSelectionService: RequestsSelectionService
    ) { }

    ngOnInit(): void {
        this.requestsSelectionSubscription = this.requestsSelectionService.requestsForced$.subscribe(
            (value) => {
                this.requestsSelectionSubscription = this.requestsService.searchRequests(value)
                    .subscribe((response) => {
                        this.requests = response;
                    });
            }
        );
    }

    ngOnDestroy() {
        if (this.requestsSelectionSubscription) {
            this.requestsSelectionSubscription.unsubscribe();
        }
    }

    requestChange(value: string): void {
        if (value && value != '' && this.requests.some(x => x.requestId.toString() == value)) {
            window.open(`/requests/${value}`, '_blank');
        }
    }

    requestsFilterChange(value: string): void {
        if (!value || value.trim() == '' || value.trim().length < this.minCharactesCount) {
            this.requests = [];
        }
        else {
            this.searchRequests(value);
        }
    }

    searchRequests(value: string) {
        if (this.searchDelay) {
            clearTimeout(this.searchDelay);
        }

        this.searchDelay = setTimeout(() => {
            if (this.searchSubsription) {
                this.searchSubsription.unsubscribe();
            }

            this.searching = true;
            this.searchSubsription = this.requestsService.searchRequests(value)
                .subscribe((response) => {
                    this.requests = response;
                    this.searching = false;
                });
        }, this.searchPauseTime);
    }

    getMatchedValueHtml(dataItem: RequestSearchedDto): string {
        let start = dataItem.matchedFullValue.substring(0, dataItem.matchedStartIndex);
        let middle = dataItem.matchedFullValue.substring(dataItem.matchedStartIndex, dataItem.matchedEndIndex + 1);
        let end = dataItem.matchedFullValue.substring(dataItem.matchedEndIndex + 1);

        let resultString = '';

        if (start && start != '') {
            resultString += start
        }
        
        resultString += `<b>${middle}</b>`;

        if (end && end != '') {
            resultString += end;
        }

        return resultString;
    }
}